import React, { useEffect } from 'react';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        
        <div className="prose prose-blue max-w-none">
          <p className="text-lg text-gray-700 mb-6">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Introduction</h2>
            <p>
              Frederick Metabolic & Primary Care Associates ("we," "our," or "us") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website 
              and use our services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Information We Collect</h2>
            <h3 className="text-xl font-medium text-gray-900 mb-3">Personal Information</h3>
            <p>We may collect personal information that you voluntarily provide, including but not limited to:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Name, email address, and phone number</li>
              <li>Medical history and health information</li>
              <li>Insurance information</li>
              <li>Appointment requests and preferences</li>
            </ul>

            <h3 className="text-xl font-medium text-gray-900 mb-3">Automatically Collected Information</h3>
            <p>When you visit our website, we may automatically collect:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>IP address and browser information</li>
              <li>Device information</li>
              <li>Usage data and cookies</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">How We Use Your Information</h2>
            <p>We use the collected information for:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Providing and improving our medical services</li>
              <li>Communicating with you about appointments and care</li>
              <li>Processing insurance and payment information</li>
              <li>Complying with legal and regulatory requirements</li>
              <li>Improving our services</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">HIPAA Compliance</h2>
            <p>
              We comply with the Health Insurance Portability and Accountability Act (HIPAA). Our handling of your 
              protected health information (PHI) is governed by our Notice of Privacy Practices, which is available 
              upon request.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Information Sharing</h2>
            <p>We may share your information with:</p>
            <ul className="list-disc pl-6 mb-4">
              <li>Healthcare providers involved in your care</li>
              <li>Insurance companies for billing purposes</li>
              <li>Service providers who assist in our operations</li>
              <li>Legal authorities when required by law</li>
            </ul>
          </section>

   

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, please contact us at:
            </p>
            <div className="mt-4">
              <p>Frederick Metabolic & Primary Care Associates</p>
              <p>184 Thomas Johnson Drive, Suite 201</p>
              <p>Frederick, MD 21701</p>
              <p>Phone: 240-949-7519</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
} 